import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets';
import { UseKeyInsightsSectionsKitResponse } from './types/keyInsightsSectionKit.types';

async function getKeyInsightsSectionsKit(kitId?: string) {
  if (!kitId) return [];

  return API.get(
    apiName,
    `${apiBasePath}/key-insights-section-kit/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.RESULTS,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        kitId,
      },
    },
  );
}

export default function useKeyInsightsSectionsKit(kitId?: string) {
  return useSuspenseQuery<UseKeyInsightsSectionsKitResponse>({
    queryKey: [apiName, 'getKeyInsightsSectionsKit', kitId],
    queryFn: () => getKeyInsightsSectionsKit(kitId),
  });
}
